/**
 * roboto-and-google-sans-from-google-maps-prevent
 * This Script use insertBefore method before the Google script invokes it.
 * and loads the Fonts locally.
 * @param fontPath
 */

class PageWrapper {
    constructor(elem) {
        this.elem = elem;
        this.fontPath = '/wp-content/themes/colliers/fonts/';
    }

    init() {
        const hasMap = document.getElementById('map-container');
        if (hasMap !== null) {
            this.fontGoogleMapsPrevent(this.fontPath);
        }
    }

    fontGoogleMapsPrevent(fontPath) {
        const head = document.getElementsByTagName('head')[0];
        const { insertBefore } = head;
        let loadedFont = 0;
        head.insertBefore = function (newElement, referenceElement) {
            if (newElement.href && newElement.href.indexOf('https://fonts.googleapis.com/css?family=') === 0) {
                if (loadedFont) {
                    return;
                }
                loadedFont = 1;

                newElement = document.createElement('style');
                newElement.innerHTML = `${'@font-face {\n'
                    + '    font-family: "Roboto";\n'
                    + '    font-style: normal;\n'
                    + '    font-weight: 400;\n'
                    + '    src: url("'}${fontPath}roboto-v30-latin-regular.woff2") format("woff2"); \n`
                    + '}\n'
                    + '@font-face {\n'
                    + '    font-family: "Roboto";\n'
                    + '    font-style: normal;\n'
                    + '    font-weight: 500;\n'
                    + `    src: url("${fontPath}roboto-v30-latin-500.woff2") format("woff2"); \n`
                    + '}';
                document.getElementsByTagName('head')[0].appendChild(newElement);
                return;
            }
            insertBefore.call(head, newElement, referenceElement);
        };
    }
}

export default PageWrapper;
